// 🎨 Brand ranglar — butun app shu yerdan oladi
export const BRAND = "#3B82F6";
export const BRAND_BG = "rgba(59, 130, 246, 0.1)";
export const BRAND_BG_HOVER = "rgba(59, 130, 246, 0.15)";
export const BRAND_BORDER = "rgba(59, 130, 246, 0.25)";
export const BRAND_BORDER_HOVER = "rgba(59, 130, 246, 0.4)";

// Common ranglar (kerak bo'lganda)
export const DANGER = "#EF4444";
export const SUCCESS = "#22C55E";
export const WARNING = "#F59E0B";

// Card style — har joyda ishlatamiz
export const cardBase: React.CSSProperties = {
  background: "var(--card)",
  border: "1px solid var(--border)",
  borderRadius: 14,
};
